module.exports = __webpack_public_path__ + "media/src/application/media/animation/title-b0e1bf4f5f7a9274874cc5399214247b.svg";